export const HEADER_NOTIFICATION_MODES = {
  session: 'session',
  showOnce: 'show-once',
};

export const DEFAULT_HEADER_NOTIFICATION_MODE = HEADER_NOTIFICATION_MODES.showOnce;
